import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3z","key":"svg-0"}]]

const IconCrop54Filled = createReactComponent('filled', 'crop-5-4-filled', 'Crop54Filled', __iconNode);

export default IconCrop54Filled;